module.exports = __webpack_public_path__ + "static/media/genuine-background-TH.4052e022.png";